import { DUNGEON_REWARDS } from '../data/entrance-types';

const REWARD_MAP = new Map(DUNGEON_REWARDS.map(r => [r.id, r]));

interface ZoneRewardDisplayProps {
  rewards: string[];
}

export function ZoneRewardDisplay({ rewards }: ZoneRewardDisplayProps) {
  if (rewards.length === 0) return null;

  return (
    <div className="flex items-center gap-0.5">
      {rewards.map((id) => {
        const reward = REWARD_MAP.get(id);
        if (!reward) return null;
        return (
          <img
            key={id}
            src={reward.image}
            alt={reward.label}
            title={reward.label}
            className="w-3.5 h-3.5"
            style={{ imageRendering: 'pixelated' }}
          />
        );
      })}
    </div>
  );
}
